import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es7.array.includes.js";
export default {
  props: {
    level: {
      type: String,
      required: true,
      validator(value) {
        return ['heading1', 'heading2', 'heading3'].includes(value);
      }
    },
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      resolver: {
        heading1: 'h1',
        heading2: 'h2',
        heading3: 'h3'
      }
    };
  },
  computed: {
    textContent() {
      return this.text ? this.text.replace(/\n/g, '<br />') : '';
    }
  }
};